// @ts-ignore
// TODO: Fix issues with next/navigation types
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';

const useUpdateSearchParams = () => {
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();

  const updateSearchParams = useCallback(
    (params: Record<string, any>, options?: { replace?: boolean; scroll?: boolean }) => {
      const newSearchParams = new URLSearchParams(searchParams);

      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== '') {
          newSearchParams.set(key, String(value));
        } else {
          newSearchParams.delete(key);
        }
      });

      // const search = newSearchParams.toString();
      // const query = search ? `?${search}` : '';

      if (options?.replace) {
        // router.replace(pathname + query, {
        //   scroll: options?.scroll ?? false,
        // });
      } else {
        // router.push(pathname + query, {
        //   scroll: options?.scroll ?? false,
        // });
      }
    },
    [pathname, router, searchParams]
  );

  const getSearchParam = useCallback(
    (key: string) => {
      return searchParams.get(key);
    },
    [searchParams]
  );

  return {
    updateSearchParams,
    getSearchParam,
    searchParams,
  };
};

export default useUpdateSearchParams;
